import React from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import { FlexContainer } from "./styled/Container.styled";
import { useResponsivePadding } from "../hooks/useResponsivePadding";
import NavbarAccountInfo from "./NavbarAccountInfo";

const PageLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { mainContainer } = useResponsivePadding();

  return (
    <FlexContainer
      padding={mainContainer}
      gap={isMobile ? "15px" : "25px"}
      alignitems="stretch"
      flexdirection="column"
    >
      {isMobile && <NavbarAccountInfo />}
      {children}
    </FlexContainer>
  );
};

export default PageLayout; 